var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-container"},[_c('el-container',[_c('el-aside',{attrs:{"width":_vm.sidebar.opened ? '210px' : '64px'}},[_c('sidebar')],1),_c('el-container',[_c('el-header',{attrs:{"height":"50px"}},[_c('navbar')],1),_c('el-main',[_c('app-main')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }